import { testOverridesAllowed } from "@/lib/runtime/env"
import type { OnboardingFlowAssignment } from "@/platform/experiments/onboarding-flow"
import type { TreatmentConfig } from "@/platform/experiments/types"

interface CheckoutOverrides {
  verificationPathExperiment?: TreatmentConfig<string>
  allowDlAndPassport?: TreatmentConfig<boolean>
  skipOnfidoSelfieValidation?: TreatmentConfig<boolean>
  showDeliveryNotesField?: TreatmentConfig<boolean>
  checkoutRedesign?: TreatmentConfig<boolean>
  onboardingFlow?: OnboardingFlowAssignment
}

export const readCheckoutOverride = <K extends keyof CheckoutOverrides>(key: K, fallback: NonNullable<CheckoutOverrides[K]>): NonNullable<CheckoutOverrides[K]> => {
  if (testOverridesAllowed && typeof window !== "undefined") {
    const override = (window as Window & { __checkoutOverrides?: CheckoutOverrides }).__checkoutOverrides?.[key]
    if (override !== undefined) return override
  }
  return fallback
}
